import { render } from "./EditTaskModal.vue?vue&type=template&id=1d91c034&scoped=true"
import script from "./EditTaskModal.vue?vue&type=script&lang=js"
export * from "./EditTaskModal.vue?vue&type=script&lang=js"

import "./EditTaskModal.vue?vue&type=style&index=0&id=1d91c034&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d91c034"]])

export default __exports__